import Vue from "vue";
import VueRouter from "vue-router";
import { isUserLoggedIn } from "@/auth/utils";
import { canNavigate } from "@/libs/acl/routeProtection";
import store from "@/store";
import VueCookies from "vue-cookies-reactive";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",
    base: "/",
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    routes: [
        {
            path: "/",
            redirect: "/:prefix/order",
            name: "home"
        },
        {
            path: "/logout",
            name: "logout",
            component: () => import("@/views/pages/logout/logout.vue"),
            meta: {
                layout: "full",
                action: "read",
                resource: "basic"
            }
        },
        {
            path: "/:prefix/resource-loading",
            name: "resource-loading",
            component: () => import("@/views/pages/dashboard/ResourceLoading.vue"),
            meta: {
                resource: "pcp",
                breadcrumb: [
                    {
                        text: "Dashboards"
                    },
                    {
                        text: "Resource Loading",
                        active: true,
                        icon: "dashboard"
                    }
                ]
            }
        },
        {
            path: "/:prefix/schedule-analysis",
            name: "schedule-analysis",
            component: () => import("@/views/pages/dashboard/ScheduleAnalysis.vue"),
            meta: {
                resource: "pcp",
                breadcrumb: [
                    {
                        text: "Dashboards",
                        active: true
                    },
                    {
                        text: "Schedule Analysis",
                        active: true,
                        icon: "dashboard"
                    }
                ]
            }
        },
        {
            path: "/:prefix/dashboard/man-hour",
            name: "dashboard-man-hour",
            component: () => import("@/views/pages/dashboard/man-hour/index.vue"),
            meta: {
                resource: "pcp",
                breadcrumb: [
                    {
                        text: "Dashboards"
                    },
                    {
                        text: "Hora Homem",
                        active: true,
                        icon: "dashboard"
                    }
                ]
            }
        },
        {
            path: "/:prefix/dashboard/oee",
            name: "dashboard-oee",
            component: () => import("@/views/pages/dashboard/oee/index.vue"),
            meta: {
                resource: "pcp",
                breadcrumb: [
                    {
                        text: "Dashboards"
                    },
                    {
                        text: "OEE",
                        active: true,
                        icon: "dashboard"
                    }
                ]
            }
        },
        {
            path: "/:prefix/dashboard/quality",
            name: "dashboard-quality",
            component: () => import("@/views/pages/dashboard/quality/index.vue"),
            meta: {
                resource: "pcp",
                breadcrumb: [
                    {
                        text: "Dashboards"
                    },
                    {
                        text: "Qualidade",
                        active: true,
                        icon: "dashboard"
                    }
                ]
            }
        },
        {
            path: "/:prefix/dashboard/stops",
            name: "dashboard-stops",
            component: () => import("@/views/pages/dashboard/stops/index.vue"),
            meta: {
                resource: "pcp",
                breadcrumb: [
                    {
                        text: "Dashboards"
                    },
                    {
                        text: "Paradas",
                        active: true,
                        icon: "dashboard"
                    }
                ]
            }
        },
        {
            path: "/:prefix/dashboard/resource-occupation",
            name: "dashboard-resource-occupation",
            component: () => import("@/views/pages/dashboard/resource-occupation/index.vue"),
            meta: {
                resource: "pcp",
                breadcrumb: [
                    {
                        text: "Dashboards"
                    },
                    {
                        text: "Ocupação de Recursos",
                        active: true,
                        icon: "dashboard"
                    }
                ]
            }
        },
        {
            path: "/:prefix/dashboard/resource-status",
            name: "dashboard-resource-status",
            component: () => import("@/views/pages/dashboard/resource-status/index.vue"),
            meta: {
                resource: "pcp",
                breadcrumb: [
                    {
                        text: "Dashboards"
                    },
                    {
                        text: "Status dos Recursos",
                        active: true,
                        icon: "dashboard"
                    }
                ]
            }
        },
        {
            path: "/:prefix/dashboard/daily-summary",
            name: "dashboard-daily-summary",
            component: () => import("@/views/pages/dashboard/daily-summary/index.vue"),
            meta: {
                resource: "pcp",
                breadcrumb: [
                    {
                        text: "Dashboards"
                    },
                    {
                        text: "Resumo Diário",
                        active: true,
                        icon: "dashboard"
                    }
                ]
            }
        },
        {
            path: "/:prefix/order",
            name: "order-list",
            component: () => import("@/views/pages/order/OrderList.vue"),
            meta: {
                resource: "pcp",
                breadcrumb: [
                    {
                        text: "Orders",
                        active: true,
                        icon: "order"
                    }
                ]
            }
        },
        {
            path: "/:prefix/order-details/:operation_id",
            name: "order-details",
            component: () => import("@/views/pages/order/OrderDetails.vue"),
            meta: {
                resource: "pcp",
                breadcrumb: [
                    {
                        text: "Orders",
                        to: { name: "order-list" },
                        icon: "order"
                    },
                    {
                        text: "Informations",
                        active: true
                    }
                ]
            }
        },
        {
            path: "/:prefix/production-progress/:operation_id?",
            name: "production-progress",
            component: () => import("@/views/pages/production-progress/ProductionProgress.vue"),
            meta: {
                resource: "pcp",
                breadcrumb: [
                    {
                        text: "Production Progress",
                        active: true,
                        icon: "operation"
                    }
                ]
            }
        },
        {
            path: "/:prefix/production-analysis",
            name: "production-analysis",
            component: () => import("@/views/pages/dashboard/production-analysis/index.vue"),
            meta: {
                resource: "pcp",
                breadcrumb: [
                    {
                        text: "Dashboards"
                    },
                    {
                        text: "ProductionAnalysis.Title",
                        active: true,
                        icon: "dashboard"
                    }
                ]
            }
        },
        {
            path: "/:prefix/operator/extrusion/resources",
            name: "operator-extrusion-resources",
            component: () => import("@/views/pages/extrusion/ExtrusionResourceList.vue"),
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/:prefix/operator/extrusion/panel/:resourceId",
            name: "operator-extrusion-panel",
            component: () => import("@/views/pages/extrusion/ExtrusionPanel.vue"),
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/:prefix/operator/extrusion/furnaces",
            name: "operator-extrusion-furnaces",
            component: () => import("@/views/pages/extrusion/ExtrusionFurnaces.vue"),
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/:prefix/operator/extrusion/furnaces/:furnaceId/assembly",
            name: "operator-extrusion-furnace-assembly",
            component: () => import("@/views/pages/extrusion/FurnaceChargeAssembly.vue"),
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/error-404",
            name: "error-404",
            component: () => import("@/views/error/Error404.vue"),
            meta: {
                layout: "full",
                action: "read",
                resource: "basic"
            }
        },
        {
            path: "/:prefix/not-authorized",
            name: "not-authorized",
            component: () => import("@/views/pages/miscellaneous/NotAuthorized.vue"),
            meta: {
                layout: "full",
                action: "read",
                resource: "basic"
            }
        },
        {
            path: "/:prefix/authenticate-required",
            name: "authenticate-required",
            component: () => import("@/views/pages/miscellaneous/AuthenticateRequired.vue"),
            meta: {
                layout: "full",
                action: "read",
                resource: "basic"
            }
        },
        {
            path: "/:prefix/account-setting",
            name: "account-setting",
            component: () => import("@/views/pages/account-setting/AccountSetting.vue"),
            meta: {
                resource: "operator",
                action: "read",
                breadcrumb: [
                    {
                        text: "Account Settings",
                        active: true,
                        icon: "profile"
                    }
                ]
            }
        },
        {
            path: "/:prefix/support",
            name: "support",
            component: () => import("@/views/pages/support/Support.vue"),
            meta: {
                resource: "basic",
                breadcrumb: [
                    {
                        text: "Support",
                        active: true,
                        icon: "profile"
                    }
                ]
            }
        },
        {
            path: "/:prefix/operator",
            name: "operator",
            component: () => import("@/views/pages/operator/Operator.vue"),
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/:prefix/operator/menu/resources",
            name: "operator-resources-menu",
            component: () => import("@/views/pages/operator/OperatorSectionMenu.vue"),
            props: { section: "resources" },
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/:prefix/operator/menu/orders",
            name: "operator-orders-menu",
            component: () => import("@/views/pages/operator/OperatorSectionMenu.vue"),
            props: { section: "orders" },
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/:prefix/operator/events/resources",
            name: "operator-events-resource",
            component: () => import("@/views/pages/operator/events/Resources.vue"),
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/:prefix/operator/favorite-resources",
            name: "operator-favorite-resources",
            component: () => import("@/views/pages/operator/FavoriteResources.vue"),
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/:prefix/operator/resources",
            name: "operator-resources",
            component: () => import("@/views/pages/operator/Resources.vue"),
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/:prefix/operator/orders",
            name: "operator-orders-all",
            component: () => import("@/views/pages/operator/Orders.vue"),
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/:prefix/operator/order-groupings",
            name: "operator-order-groupings",
            component: () =>
                import("@/views/pages/operator/order-grouping/OrderGroupingList.vue"),
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/:prefix/operator/sap-integration-report",
            name: "operator-sap-integration-report",
            component: () =>
                import("@/views/pages/operator/sap-integration/SapIntegrationReport.vue"),
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/:prefix/operator/order-groupings/new",
            name: "operator-order-grouping-new",
            component: () =>
                import("@/views/pages/operator/order-grouping/OrderGroupingForm.vue"),
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/:prefix/operator/order-groupings/:id/edit",
            name: "operator-order-grouping-edit",
            component: () =>
                import("@/views/pages/operator/order-grouping/OrderGroupingForm.vue"),
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/:prefix/operator/order-groupings/:id/appointment",
            name: "operator-order-grouping-appointment",
            component: () =>
                import("@/views/pages/operator/order-grouping/OrderGroupingAppointment.vue"),
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/:prefix/operator/order-groupings/:id/history",
            name: "operator-order-grouping-history",
            component: () =>
                import("@/views/pages/operator/order-grouping/OrderGroupingHistory.vue"),
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/:prefix/operator/order-groupings/:id",
            name: "operator-order-grouping-detail",
            component: () =>
                import("@/views/pages/operator/order-grouping/OrderGroupingDetail.vue"),
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/:prefix/operator/multiple-orders",
            name: "operator-multiple-orders",
            component: () => import("@/views/pages/operator/MultipleOrders.vue"),
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/:prefix/operator/multiple-orders-quantity/:resource_id/:preactor_orders",
            name: "operator-multiple-orders-quantity",
            component: () => import("@/views/pages/operator/MultipleOrdersQuantity.vue"),
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/:prefix/operator/barcode",
            name: "operator-barcode",
            component: () => import("@/views/pages/operator/Barcode.vue"),
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/:prefix/operator/barcode-status",
            name: "operator-barcode-status",
            component: () => import("@/views/pages/operator/BarcodeStatus.vue"),
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/:prefix/operator/barcode-status/print",
            name: "operator-barcode-status-print",
            component: () => import("@/views/pages/operator/BarcodeStatusPrint.vue"),
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/:prefix/operator/order-tracking",
            name: "operator-order-tracking",
            component: () => import("@/views/pages/operator/OrderTracking/index.vue"),
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/:prefix/operator/point-resource/:resource_id/:order_id/:material_id/:max_orders?/:current_order?",
            name: "operator-point-resource",
            component: () => import("@/views/pages/operator/ProductionProgress/index.vue"),
            meta: {
                resource: "operator",
                action: "read"
            }
        },
        {
            path: "/:prefix/operator/production-progress/:resource_id/:order_id/:return_orders/:multiple?/appointment_type=:appointment_type?",
            name: "operator-production-progress",
            component: () => import("@/views/pages/operator/ProductionProgress/index.vue"),
            meta: {
                resource: "operator",
                action: "read",
                breadcrumb: [
                    {
                        text: "Orders",
                        active: false,
                        to: { name: "operator" },
                        icon: "operator"
                    },
                    {
                        text: "Production Progress",
                        active: true,
                        icon: "operator"
                    }
                ]
            }
        },
        {
            path: "/:prefix/operator/production-progress-multiple/:resource_id/:multiple/:return_orders?/preactor_orders=:preactor_orders?/appointment_type=:appointment_type?",
            name: "operator-production-progress-multiple",
            component: () => import("@/views/pages/operator/ProductionProgress/index.vue"),
            meta: {
                resource: "operator",
                action: "read",
                breadcrumb: [
                    {
                        text: "Orders",
                        active: false,
                        to: { name: "operator" },
                        icon: "operator"
                    },
                    {
                        text: "Production Progress",
                        active: true,
                        icon: "operator"
                    }
                ]
            }
        },
        {
            path: "/:prefix/change-account",
            name: "change-account",
            component: () => import("@/views/pages/account-setting/ChangeAccount.vue"),
            meta: {
                resource: "basic",
                action: "read"
            }
        },
        {
            path: "*",
            redirect: "error-404"
        },
        {
            path: "/:prefix/date-time-picker",
            name: "date-time-picker",
            component: () => import("@/views/DateTimePickerView.vue")
        }
    ]
});

router.beforeEach(async (to, from, next) => {
    const hasToken = !!localStorage.getItem("accessToken");
    const cookieUserInfo = VueCookies.get("userInfo");

    if (!hasToken && cookieUserInfo) {
        console.log("Router: Restaurando sessão via Cookie...");

        if (cookieUserInfo.temporaryToken) {
            localStorage.setItem("accessToken", cookieUserInfo.temporaryToken);
        }

        if (cookieUserInfo.userData) {
            localStorage.setItem("userData", JSON.stringify(cookieUserInfo.userData));
        }

        const company = VueCookies.get("company");
        if (company) {
            localStorage.setItem("prefix", company);
        }
    }

    let hasUserData = !!localStorage.getItem("userData");

    if (to?.name === "change-account") return next();

    if (hasToken && !hasUserData) {
        try {
            await store.dispatch("auth/fetchPermissions");
            hasUserData = !!localStorage.getItem("userData");
        } catch (error) {
            console.error(
                "Router: Falha ao buscar dados do usuário. Redirecionando para login.",
                error
            );
            return next({ name: "change-account" });
        }
    }

    if (to?.name !== "change-account" && hasUserData && !hasToken) {
        return next({
            name: "change-account",
            params: { prefix: localStorage.getItem("prefix") }
        });
    }

    let pcpAccess = false;
    let operatorAccess = false;

    try {
        const permissions = store.getters["auth/getPermissions"] || [];
        if (permissions.length > 0) {
            const mysfc = permissions.find((perm) => perm.name === "mysfc");
            const pcp = mysfc?.children?.find((child) => child.name === "pcp");
            const operator = mysfc?.children?.find((child) => child.name === "operator");

            pcpAccess = !!(pcp && ((pcp.options && pcp.options.length > 0) || (pcp.children && pcp.children.length > 0)));
            operatorAccess = !!(operator && ((operator.options && operator.options.length > 0) || (operator.children && operator.children.length > 0)));
        }

        if (!pcpAccess && !operatorAccess) {
            const userDataStr = localStorage.getItem("userData");
            if (userDataStr) {
                const userData = JSON.parse(userDataStr);
                const ability = userData.ability || [];

                pcpAccess = ability.some(
                    (r) => (r.action === "manage" && r.subject === "all") || r.subject?.toLowerCase() === "pcp"
                );

                operatorAccess = ability.some(
                    (r) => (r.action === "manage" && r.subject === "all") || r.subject?.toLowerCase() === "operator"
                );
            }
        }
    } catch (e) {
        console.error("Router: Erro ao ler permissões", e);
    }

    const isLoggedIn = isUserLoggedIn();

    if (to.meta.redirectIfLoggedIn && isLoggedIn) {
        return next({ name: "home", params: { prefix: to.params.prefix } });
    }

    if (!canNavigate(to)) {
        let targetRouteName = "change-account";

        if (pcpAccess) targetRouteName = "home";
        else if (operatorAccess) targetRouteName = "operator";

        if (to.meta.resource === "pcp" && pcpAccess) return next();
        if (to.meta.resource === "operator" && operatorAccess) return next();

        if (to.name === targetRouteName) {
            return next();
        }

        return next({
            name: targetRouteName,
            params: { prefix: localStorage.getItem("prefix") }
        });
    }
    return next();
});

router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById("loading-bg");
    if (appLoading) {
        appLoading.style.display = "none";
    }
});

export default router;
